export const BIGGEST_LOSER = {
  prefix: "$",
  value: 2052.84,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 2,
};
